export type Settings = {
  sensitivity: number;
  fov: number;
  viewmodelFov: number;
  autoBhop: boolean;
  velocity: boolean;
  timer: boolean;
  ghosts: boolean;
  renderScale: number;
  textureQuality: string;
  antialias: boolean;
  fpsLimit: number;
  master: number;
  game: number;
  ui: number;
  pbDelta: boolean;
  otherPlayers: boolean;
  rawInput: boolean;
  ambience: number;
  viewmodelBob: "off" | "low" | "normal";
  binds: Record<string, string[]>;
};
const defaults: Settings = {
  sensitivity: 1,
  fov: 100,
  viewmodelFov: 70,
  autoBhop: true,
  velocity: true,
  timer: true,
  ghosts: true,
  renderScale: 1,
  textureQuality: "high",
  antialias: true,
  fpsLimit: 0,
  pbDelta: true,
  otherPlayers: true,
  rawInput: true,
  ambience: 0.3,
  viewmodelBob: "low",
  master: 0.55,
  game: 0.5,
  ui: 0.4,
  binds: {
    forward: ["KeyW"],
    back: ["KeyS"],
    left: ["KeyA"],
    right: ["KeyD"],
    jump: ["Space"],
    duck: ["ControlLeft", "KeyC"],
    restart: ["KeyR"],
    stage: ["KeyT"],
    unstick: ["KeyZ"],
    inspect: ["KeyF"],
    draw: ["KeyQ"],
    scoreboard: ["Tab"],
    pause: ["Escape"],
  },
};
export let settings: Settings = { ...defaults, binds: { ...defaults.binds } };
try {
  const stored = JSON.parse(localStorage.getItem("frog-settings") ?? "{}");
  settings = {
    ...defaults,
    ...stored,
    binds: Object.fromEntries(
      Object.entries({ ...defaults.binds, ...stored.binds }).map(([k, v]) => [
        k,
        Array.isArray(v)
          ? v
          : typeof v === "string"
            ? k === "duck" && v === "ControlLeft"
              ? [v, "KeyC"]
              : [v]
            : defaults.binds[k],
      ]),
    ),
  };
} catch {}
export function saveSettings() {
  localStorage.setItem("frog-settings", JSON.stringify(settings));
}

export const bound = (action: string, code: string) =>
  settings.binds[action]?.includes(code) ?? false;
